const SquareWalletIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 25.0461 0 17.5692 3.21539 12C5.32183 8.35154 8.35154 5.32183 12 3.21539C17.5692 0 25.0461 0 40 0C54.9539 0 62.4308 0 68 3.21539C71.6485 5.32183 74.6782 8.35154 76.7846 12C80 17.5692 80 25.0461 80 40C80 54.9539 80 62.4308 76.7846 68C74.6782 71.6485 71.6485 74.6782 68 76.7846C62.4308 80 54.9539 80 40 80C25.0461 80 17.5692 80 12 76.7846C8.35154 74.6782 5.32183 71.6485 3.21539 68C0 62.4308 0 54.9539 0 40Z"
        fill="#0E386D"
      />
      <path
        d="M50.4917 28.9636C49.5719 28.6737 48.5382 28.5329 47.344 28.4592C45.9789 28.375 44.3201 28.375 42.2849 28.375H37.6911C35.286 28.375 33.4006 28.375 31.8943 28.5182C30.359 28.6642 29.1018 28.9669 27.9936 29.646C26.833 30.3572 25.8573 31.3329 25.1461 32.4934C25.1209 32.5346 25.0962 32.5759 25.0721 32.6174C25.188 30.4527 25.4908 29.019 26.2818 27.884C26.6957 27.29 27.1968 26.7677 27.7665 26.3362C29.5305 25 32.0469 25 37.0798 25H45.1328C47.6637 25 48.9291 25 49.7153 25.8197C50.3192 26.4492 50.4592 27.3734 50.4917 28.9636Z"
        fill="white"
      />
      <path
        d="M26.1052 33.0813C25 34.8848 25 37.3399 25 42.25C25 47.1601 25 49.6152 26.1052 51.4187C26.7236 52.4279 27.5721 53.2764 28.5813 53.8948C30.3848 55 32.8399 55 37.75 55H42.25C47.1601 55 49.6152 55 51.4187 53.8948C52.4279 53.2764 53.2764 52.4279 53.8948 51.4187C54.6206 50.2343 54.8698 48.7688 54.9553 46.5114H45.4547C42.574 46.5114 40.2388 44.1762 40.2388 41.2955C40.2388 38.4148 42.574 36.0796 45.4547 36.0796H54.8165C54.6662 34.8381 54.3926 33.8936 53.8948 33.0813C53.2764 32.0721 52.4279 31.2236 51.4187 30.6052C51.1315 30.4292 50.8276 30.2811 50.5 30.1567C48.7708 29.5 46.378 29.5 42.25 29.5H37.75C32.8399 29.5 30.3848 29.5 28.5813 30.6052C27.5721 31.2236 26.7236 32.0721 26.1052 33.0813Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.9668 38.3296H45.4547C43.8167 38.3296 42.4888 39.6575 42.4888 41.2955C42.4888 42.9335 43.8167 44.2614 45.4547 44.2614H54.9965C55 43.6401 55 42.9716 55 42.25C55 40.7241 55 39.4354 54.9668 38.3296ZM45.4547 40.1705C44.8334 40.1705 44.3297 40.6742 44.3297 41.2955C44.3297 41.9168 44.8334 42.4205 45.4547 42.4205H49.5456C50.1669 42.4205 50.6706 41.9168 50.6706 41.2955C50.6706 40.6742 50.1669 40.1705 49.5456 40.1705H45.4547Z"
        fill="white"
      />
    </svg>
  )
}

export default SquareWalletIcon
